import React from "react";
import {
  FileText,
  Sheet,
  Mail,
  Calendar,
  CreditCard,
  MessageSquare,
  Zap,
  Database,
  Users,
  ClipboardEdit,
  KanbanSquare,
  ListChecks,
  Inbox,
  Table,
} from "lucide-react";

const integrations = [
  { name: "Notion", Icon: FileText, color: "#FFFFFF" },
  { name: "Google Sheets", Icon: Sheet, color: "#34A853" },
  { name: "Gmail", Icon: Mail, color: "#EA4335" },
  { name: "Google Calendar", Icon: Calendar, color: "#4285F4" },
  { name: "Airtable", Icon: Database, color: "#FCB400" },
  { name: "Stripe", Icon: CreditCard, color: "#635BFF" },
  { name: "Slack", Icon: MessageSquare, color: "#4A154B" },
  { name: "HubSpot", Icon: Users, color: "#FF7A59" },
  { name: "Monday.com", Icon: KanbanSquare, color: "#FF3D57" },
  { name: "Typeform", Icon: ClipboardEdit, color: "#262626" },
  { name: "Google Forms", Icon: ListChecks, color: "#673AB7" },
  { name: "Outlook", Icon: Inbox, color: "#0078D4" },
  { name: "Zapier", Icon: Zap, color: "#FF4F00" },
  { name: "Microsoft Excel", Icon: Table, color: "#1D6F42" },
];

const Tile = ({ name, Icon, color }) => (
  <div className="integration-tile shrink-0 w-[160px] md:w-[180px] mx-2 md:mx-3 px-5 py-5 rounded-2xl border flex flex-col items-center justify-center gap-3 transition-all duration-300 hover:-translate-y-1">
    <div
      className="w-12 h-12 rounded-xl flex items-center justify-center"
      style={{
        backgroundColor: "color-mix(in srgb, " + color + " 14%, transparent)",
        color: color === "#FFFFFF" || color === "#262626" ? "var(--text)" : color,
      }}
    >
      <Icon size={22} />
    </div>
    <span className="text-sm font-medium" style={{ color: "var(--text)" }}>{name}</span>
  </div>
);

export const IntegrationTicker = () => {
  // Duplicate the list for a seamless loop
  const tiles = [...integrations, ...integrations];
  return (
    <div className="ticker-mask relative w-full overflow-hidden" data-testid="integration-ticker">
      <div className="ticker-track flex">
        {tiles.map((t, i) => (
          <Tile key={`${t.name}-${i}`} name={t.name} Icon={t.Icon} color={t.color} />
        ))}
      </div>
    </div>
  );
};

export default IntegrationTicker;
